import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { getDiscountedValues } from '../../../migrate-plan-modal/helpers';
import { useAdditionalUserCountCostForBillingPlanId } from '../../../../hooks/use-plan-details';

import { messages } from './messages';

import style from '../plan-details.module.less';

/**
 * @param {object} props
 * @param {string} props.billingPlanId
 * @param {number} props.additionalUsers
 * @param {number} [props.discountPercent]
 * @returns {React.JSX.Element}
 */
export const UserCost = ({ billingPlanId, additionalUsers, discountPercent }) => {
  const cost = useAdditionalUserCountCostForBillingPlanId(billingPlanId, additionalUsers);

  if (!cost?.value) {
    return (
      <Text
        className={style['plan-option-content-cost']}
        element='span'
        textType={TextType.Caption}
        value={<FormattedMessage {...messages.includedAbbreviation} />}
      />
    );
  }

  const hasDiscount = discountPercent != null && discountPercent > 0;
  const discountedPrice = hasDiscount
    ? getDiscountedValues({ fullPrice: cost.value, discountPercentage: discountPercent / 100 }).discountedPrice
    : null;

  const message = hasDiscount ? (
    <FormattedMessage
      {...messages.userCountAdditionalCost}
      values={{
        cost: (
          <>
            <span className={style['plan-option-content-cost-strikethrough']}>
              <FormattedCurrency currencyCode={cost.code} value={cost.value} />
            </span>
            <FormattedCurrency currencyCode={cost.code} value={discountedPrice} />
          </>
        ),
      }}
    />
  ) : (
    <FormattedMessage
      {...messages.userCountAdditionalCost}
      values={{
        cost: <FormattedCurrency currencyCode={cost.code} value={cost.value} />,
      }}
    />
  );

  return <Text className={style['plan-option-content-cost']} element='span' textType={TextType.Caption} value={message} />;
};
